import { render, staticRenderFns } from "./ceiling-product-selectator.vue?vue&type=template&id=5fe94814&scoped=true"
import script from "./ceiling-product-selectator.vue?vue&type=script&lang=js"
export * from "./ceiling-product-selectator.vue?vue&type=script&lang=js"
import style0 from "./ceiling-product-selectator.vue?vue&type=style&index=0&id=5fe94814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe94814",
  null
  
)

export default component.exports